<div class="main">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="filter">
        <div class="title">
          <div class="titleLabel">{{'EXPRESS_SHIPMENTS.title' | translate}}</div>
          <!-- <div class="help">
            <app-help [helpData]="helpData"></app-help>
          </div> -->
        </div>
       
      <div class="create_trip" (click)="openCreateTripModal()">
        <div class="create_trip_btn">{{'EXPRESS_SHIPMENTS.create_trip' | translate}}</div>
      </div>
      </div>
  
  
      <div class="table">
        <table mat-table 
          [dataSource]="dataSource" matSort (matSortChange)="sortShipmentData($event)">
  
          <!-- <ng-container matColumnDef="sin">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <span>
                <input type="text" style="width: 120px;" [placeholder]="'EXPRESS_SHIPMENTS.Select' | translate"
                     (click)="stopProp($event)"
                    class="formField" />
            </span>
            </th>
            <td mat-cell *matCellDef="let element">
             
            </td>
          </ng-container> -->

          <ng-container matColumnDef="sin">
            <th mat-header-cell *matHeaderCellDef style="padding-left: 3px;">
              {{'DRIVERS.select' | translate}}
            </th>
            <td mat-cell *matCellDef="let element" style="padding-left: 2px;">
              <mat-checkbox  (change)="selectDriverType($event, element)" [(ngModel)]="element.selected"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="shipment">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{ "Shipment" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.shipment }} 
            </td>
        </ng-container>
  
          <ng-container matColumnDef="drop_location">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{ "Drop Location" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.drop_location }} 
            </td>
        </ng-container>

        <ng-container matColumnDef="client">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{ "Client" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.client }} 
            </td>
        </ng-container>

        <ng-container matColumnDef="packages">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{ "Packages" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.packages }} 
            </td>
        </ng-container>

        <ng-container matColumnDef="booking_date">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{ "Booking Date" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.booking_date }} 
            </td>
        </ng-container>

        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{ "Type" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.type }} 
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{ "Status" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.status }} 
            </td>
        </ng-container>

      

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
                {{'EXPRESS_SHIPMENTS.actions' | translate}}              
            </th>     
            <td mat-cell *matCellDef="let element" style="width: 100px;">
              <div class="actionBtn">
                <div class="button">
                  <mat-select [placeholder]="'DRIVERS.action' | translate">
                    <mat-option (click)="openShipmentDetails(element)"> <img style="width: 16px;position: relative;top: 3px;" 
                        src="assets/View.svg" alt=""> {{'EXPRESS_SHIPMENTS.view' | translate}}</mat-option>
                  </mat-select>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" ></tr>
          <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data matching the filter</td>
          </tr>

        </table>
        <mat-paginator [length]="(dataSource)? totalOrders:0" [showFirstLastButtons]="true" [pageSize]="25"
        style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;"
        [pageSizeOptions]="[5, 10, 25, 100]" (page)="pageNavigate($event)"></mat-paginator>
        <!-- <mat-paginator fixed [length]="(shipments)? totalShipments: 0" [pageSizeOptions]="[5,10,25, 50, 100]"
          [pageSize]="25" showFirstLastButtons (page)="pageNavigate($event)"></mat-paginator> -->
  
        <ng-template #noOrders>
          <div class="noOrders">
            {{'EXPRESS_SHIPMENTS.noShip' | translate}}
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <!-- <ng-template #warning>
    <div class="dialogMain">
      <div class="section">
        <div class="header">
          <div class="label">
            {{'EXPRESS_SHIPMENTS.re_assign' | translate}}<i class="material-icons"
              (click)="warningRef.close(false);">clear</i>
          </div>
        </div>
        <div class="text">
          {{'EXPRESS_SHIPMENTS.warningText' | translate}}
          <div class="reassign_radio_sec">
            <p>
              <input type="radio" id="test1" name="radio-group" checked [(ngModel)]="re_assign_type" value="driver">
              <label for="test1">{{'EXPRESS_SHIPMENTS.re_assign_driver' | translate}}</label>
            </p>
            <p class="reassign_radio_btn">
              <input type="radio" id="test2" name="radio-group" [(ngModel)]="re_assign_type" value="vehicle">
              <label for="test2">{{'EXPRESS_SHIPMENTS.re_assign_vehicle' | translate}}</label>
            </p>
            <p class="reassign_radio_btn">
              <input type="radio" id="test3" name="radio-group" [(ngModel)]="re_assign_type" value="both">
              <label for="test3">{{'EXPRESS_SHIPMENTS.both_driver_vehicle' | translate}}</label>
            </p>
          </div>
        </div>
        <div class="submitButton">
          <div class="button" (click)="warningRef.close(true);">
            {{'EXPRESS_SHIPMENTS.submit' | translate}}
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #acceptDialog>
    <div class="dialogMain">
      <div class="section">
        <div class="header">
          <div class="label">
            {{'EXPRESS_SHIPMENTS.accept' | translate}}<i class="material-icons"
              (click)="acceptRef.close(false);">clear</i>
          </div>
        </div>
        <div class="text">
          {{'EXPRESS_SHIPMENTS.acceptText' | translate}}
        </div>
        <div class="submitButton">
          <div class="button" (click)="acceptRef.close(true);">
            {{'EXPRESS_SHIPMENTS.ok' | translate}}
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  
  <ng-template #delayedShipment>
    <div class="delayDialog">
      <div class="loader" *ngIf="showLoader">
        <div class="load">
          <mat-spinner></mat-spinner>
        </div>
      </div>
      <div class="header">
        {{'EXPRESS_SHIPMENTS.delayed_shipment' | translate}}
        <i class="material-icons" (click)="delayedShipmentRef.close(false);">
          clear
        </i>
      </div>
      <div class="section">
        <div class="text">
          {{'EXPRESS_SHIPMENTS.delay_text' | translate}}
        </div>
        <div class="penalty_amount">
          {{'EXPRESS_SHIPMENTS.penalty_amount' | translate}} : {{shipmentDelayData.penalty}}
        </div>
        <div class="reasonBox">
          <textarea [required]="shipmentDelayData.reason" [placeholder]=" 'EXPRESS_SHIPMENTS.reason_waive' | translate "
            autofocus="false" [(ngModel)]="shipmentDelayData.reason"> </textarea>
        </div>
      </div>
  
      <div class="submitButton">
        <div class="button right-float" (click)="requestWaiveOff()" *ngIf="!shipmentDelayData.status">
          {{'EXPRESS_SHIPMENTS.waive_off' | translate}}
        </div>
        <div class="button left-float" (click)="delayedShipmentRef.close();" *ngIf="!shipmentDelayData.status">
          {{'EXPRESS_SHIPMENTS.cancel' | translate}}
        </div>
        <div class="disabled" *ngIf="shipmentDelayData && shipmentDelayData.status == 'PENDING'">
          {{'EXPRESS_SHIPMENTS.requested_already' | translate}}
        </div>
        <div class="green" *ngIf="shipmentDelayData && shipmentDelayData.status == 'APPROVED'">
          {{'EXPRESS_SHIPMENTS.approved' | translate}}
        </div>
      </div>
    </div>
  </ng-template> -->